import { ArrowIcon } from "@/components/RFIcon";

interface Props {
	acronym?: string;
	phoneCode: string;
	onClick: () => void;
}

export function Holder({ acronym, phoneCode, onClick }: Props) {
	return (
		<div className="flex select-none items-center whitespace-nowrap" onClick={() => onClick && onClick()}>
			<span className="m-1 font-semibold">
				{acronym} +{phoneCode.length >= 4 ? phoneCode.substring(0, 1) : phoneCode}
			</span>

			<ArrowIcon className="mx-0.5" />
			<span className="mx-2 h-[1.6rem] w-[1.5px] rf-select-divider"></span>
		</div>
	);
}
